import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ClinicDocument } from '../models/clinic-document.model';

/**
 * Read-only by design. The manual is one platform-wide document, not a copy per clinic, so a
 * clinic-side replace would overwrite what every other clinic reads. Publishing stays in the
 * superadmin console.
 */
export interface IDocumentationRepository {
  getCatalogue(): Observable<readonly ClinicDocument[]>;

  /** Streams the document through the API with the caller's session; never a public URL. */
  getContent(documentId: string): Observable<Blob>;
}

export const DOCUMENTATION_REPOSITORY = new InjectionToken<IDocumentationRepository>(
  'IDocumentationRepository',
);
